import { doodBlockConfig, propertyValue } from './dood-block-config';
import {
  buildOrderedBlockDescriptor,
  type DescriptorFieldOrderItem,
} from './descriptor-field-order';
import type { IBlockDescriptor } from './descriptor';

export const PATLAYOUT_LEGACY_FIELD_ORDER = [
  { type: 'heading', value: "pages.blocks.pat-layout-page.heading.header.label" },
  "display_header",
  "display_header_back",
  "header_text"
] as const satisfies readonly DescriptorFieldOrderItem[];

const {
  patLayoutBlockDescriptor: _generatedPatLayoutBlockDescriptor,
  patLayoutBlockBlocDefinition,
  patLayoutBlockDashboardLayout,
  patLayoutBlockConfig,
  patLayoutBlockResolveConfig,
  patLayoutBlockProperties,
} = doodBlockConfig(
  {
    name: "Pay at table Layout",
    internal_name: "Pay at table Layout",
    url: "pay-at-table",
    defaultParent: [/^Main Layout$/i],
    componentType: 'PatLayoutBlockComponent',
    category: 'page',
    description: "Pay at table Layout.",
    keywords: [],
    isRootBlock: true,
    sharedFields: {}
  },

  () => ({
    display_header: propertyValue({
      type: 'checkbox',
      value: true,
      options: {
        label: "pages.blocks.pat-layout-page.display-header.label",
      }
    }),
    display_header_back: propertyValue({
      type: 'checkbox',
      value: true,
      options: {
        label: "pages.blocks.pat-layout-page.display-header-back.label",
      }
    }),
    header_text: propertyValue({
      type: 'text',
      value: '',
      options: {
        label: "pages.blocks.pat-layout-page.header-text.label",
        help: "pages.blocks.pat-layout-page.header-text.help",
        placeholder: "Payer la note",
      }
    })
  }),

  () => ({
    tabs: [
      {
        label: "pages.blocks.pat-layout-page.tab.content.label",
        fieldsets: [
          {
            legend: "pages.blocks.pat-layout-page.fieldset.header.label",
            fields: [
              "display_header",
              {
                prop: "display_header_back",
                visibleWhen: { display_header: true },
              },
              {
                prop: "header_text",
                visibleWhen: { display_header: true },
              },
            ],
          },
        ],
      },
    ],
  })
);

export function patLayoutBlockDescriptor(): IBlockDescriptor;
export function patLayoutBlockDescriptor(
  fieldOrder: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor;
export function patLayoutBlockDescriptor(
  fieldOrder?: readonly DescriptorFieldOrderItem[],
): IBlockDescriptor {
  if (fieldOrder === undefined) {
    return _generatedPatLayoutBlockDescriptor;
  }
  return buildOrderedBlockDescriptor(_generatedPatLayoutBlockDescriptor, patLayoutBlockProperties, fieldOrder);
}

export {
  patLayoutBlockBlocDefinition,
  patLayoutBlockDashboardLayout,
  patLayoutBlockProperties,
  patLayoutBlockConfig,
  patLayoutBlockResolveConfig,
};

export type PatLayoutBlockConfig = typeof patLayoutBlockConfig;
